
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[location]/categories/[slug]/[page]",
      function () {
        return require("private-next-pages/[location]/categories/[slug]/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[location]/categories/[slug]/[page]"])
      });
    }
  